import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

const LinkTo = ({ linkInfo, className, children }) => {
  const { url, isExternal, openInNewTab } = linkInfo
  if (isExternal) {
    return (
      <a
        href={url}
        rel={openInNewTab ? "noopener noreferrer" : null}
        target={openInNewTab ? "_blank" : null}
        className={className}
      >
        {children}
      </a>
    )
  } else {
    return (
      <Link
        to={`${url.startsWith("/") ? "" : "/"}${url}`}
        className={className}
      >
        {children}
      </Link>
    )
  }
}

LinkTo.propTypes = {
  linkInfo: PropTypes.any,
  children: PropTypes.any
}
  
export default LinkTo;
